import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';

import { GlProductTypeDropdownComponent } from './gl-product-type-dropdown.component';
import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';


@NgModule({
  declarations: [
    GlProductTypeDropdownComponent
  ],
  exports: [
    GlProductTypeDropdownComponent
  ],
  imports: [
    CommonModule,
    RnplCommonModule,
    TranslateModule,
    NgSelectModule,
    UIComponentsModule,
    ReactiveFormsModule
  ],
})
export class GlProductTypeDropdownModule { }
